/**
 * @description 提供基础数据组件的配置信息
 */
import store from '@/store';
const { currentTenant } = store.state;

export const baseKey = {
    customer: {
        advanceConfig: [
            { prop: 'ebcuNameCn', value: '客户名称' },
            { prop: 'pmCode', value: '客户编码' }
        ],
        tableConfig: [
            { prop: 'pmCode', value: '客户编码' },
            { prop: 'ebcuNameCn', value: '客户名称' }
        ],
        advanceUrl: '/ebCustomer/searchByEbCustomer',
        cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName']
    },
    site: {
        advanceConfig: [
            { prop: 'escoCompanyNameCn', value: '服务平台名称' },
            { prop: 'escoCompanyNo', value: '服务平台编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNo', value: '服务平台编码' },
            { prop: 'escoCompanyNameCn', value: '服务平台名称' },
            { prop: 'branchCompanyNo', value: '分公司编码' },
            { prop: 'branchCompanyName', value: '分公司名称' }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
    },
    wh: {
        advanceConfig: [
            { prop: 'cdwhName', value: '仓库名称' },
            { prop: 'whCode', value: '仓库编码' }
        ],
        tableConfig: [
            { prop: 'whCode', value: '仓库编码' },
            { prop: 'cdwhName', value: '仓库名称' }
        ],
        advanceUrl: 'cdWarehouse/search?cdwhIsStop=0&',
        cbParams: ['whCode#whCode', 'cdwhName#whName']
    },
    carTypeCode: {
        advanceConfig: [
            { prop: 'nameCn', value: '车型' },
            { prop: 'maxVolume', value: '最大体积' },
            { prop: 'maxWeight', value: '最大重量' }
        ],
        tableConfig: [
            { prop: 'nameCn', value: '车型' },
            { prop: 'maxVolume', value: '最大体积' },
            { prop: 'maxWeight', value: '最大重量' }
        ],
        prefix: '/api-dc/',
        advanceUrl: `equipment/group/page?tenantCode=${currentTenant.tenantCode}`,
        cbParams: [
            'nameCn#equipmentName', 'maxVolume', 'maxWeight', 'code#equipmentType'
        ]
    },
    carrierCode: {
        multipleTableColumn: {
            prop: 'suppliersNameCn',
            value: '承运商名称'
        },
        advanceConfig: [
            { prop: 'suppliersNameCn', value: '承运商名称' },
            { prop: 'suppliersCode', value: '承运商编码' }
        ],
        tableConfig: [
            { prop: 'suppliersNameCn', value: '承运商名称' },
            { prop: 'suppliersCode', value: '承运商编码' }
        ],
        advanceUrl: 'ebSupplier/searchBySupplier',
        cbParams: ['suppliersNameCn#carrierName', 'suppliersCode#carrierCode']
    },
    subCompany:  {
        advanceConfig: [
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
            { prop: 'escoCompanyNo', 'value': '分公司编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNo', 'value': '分公司编码' },
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' }
        ],
        advanceUrl: '/searchBrand',
        cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
    },
};

// table内
export const tableBaseConfig = {
    customer: {
        label: '客户',
        type: 'advance',
        prop: 'customerName',
        mustFill: false,
        require: true,
        sort: true,
        width: 200,
        ...baseKey.customer
    },
    site: {
        label: '服务平台',
        type: 'advance',
        prop: 'siteName',
        mustFill: false,
        require: true,
        sort: true,
        width: 200,
        ...baseKey.site
    },
    wh: {
        label: '仓库',
        type: 'advance',
        prop: 'whName',
        mustFill: false,
        require: true,
        sort: true,
        width: 200,
        ...baseKey.wh
    },
    carrierCode: {
        label: '承运商',
        type: 'advance',
        prop: 'carrierName',
        mustFill: false,
        require: true,
        sort: true,
        width: 200,
        ...baseKey.carrierCode
    }
};

// 查询
export const searchBaseConfig = {
    customer: {
        name: '客户',
        value: 'customerName',
        type: 'advance',
        unfold: true,
        span: 4,
        ...baseKey.customer
    },
    site: {
        name: '服务平台',
        value: 'siteName',
        type: 'advance',
        unfold: true,
        span: 4,
        ...baseKey.site
    },
    wh: {
        name: '仓库',
        value: 'whName',
        type: 'advance',
        unfold: true,
        span: 4,
        ...baseKey.wh
    },
    carrierCode: {
        name: '承运商',
        value: 'carrierName',
        type: 'advance',
        unfold: true,
        span: 4,
        ...baseKey.carrierCode
    },
    subCompany:  {
        name: '分公司',
        value: 'companyName',
        unfold: true,
        type: 'advance',
        span: 3,
        ...baseKey.subCompany
    },
};

// 表单
export const formBaseConfig = {
    customer: {
        span: 8,
        change: true,
        mustFill: true,
        label: '客户名称',
        name: '客户名称',
        prop: 'customerName',
        value: 'customerName',
        type: 'advance',
        ...baseKey.customer
    },
    site: {
        span: 8,
        change: true,
        mustFill: true,
        label: '平台',
        name: '平台',
        prop: 'siteName',
        value: 'siteName',
        type: 'advance',
        ...baseKey.site
    },
    wh: {
        span: 8,
        change: true,
        mustFill: true,
        label: '仓库',
        name: '仓库',
        value: 'whName',
        prop: 'whName',
        type: 'advance',
        ...baseKey.wh
    },
    carrierCode: {
        span: 8,
        change: true,
        mustFill: true,
        label: '承运商',
        name: '承运商',
        value: 'carrierName',
        prop: 'carrierName',
        type: 'advance',
        ...baseKey.carrierCode
    },
    subCompany: {
        span: 8,
        change: true,
        mustFill: true,
        name: '分公司',
        label: '分公司',
        value: 'companyName',
        prop: 'companyName',
        type: 'advance',
        span: 3,
        ...baseKey.subCompany
    }
};

// 不配置数据字典，常用的options
export const baseOptions = {
    tcFlag: [{ value: 'C', label: '中心' }, { value: 'T', label: '统配' }]
};
